import { Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { TemplateComponent } from '../components/base/template.component';

@Pipe({ name: 'template', })
export class TemplatePipe implements PipeTransform {
  transform<T = unknown>(
    value: string,
    component: TemplateComponent,
  ): TemplateRef<T> | null {
    return component.getTemplate(value);
  }
}
